<mat-form-field>
  <mat-label>Search</mat-label>
  <input matInput [formControl]="searchControl" />
  <mat-icon matSuffix>search</mat-icon>
</mat-form-field>
